<template>
<v-app id="inspire">

    <m-global-snackbar/>

<div
    style="text-align: center; margin-top: 20px; margin-bottom: 7px;"
>
     <img 
        src="@/assets/platypus/platypus-logo.png" 
        style="max-width: 325px;"
    />
</div>



<div
    style="font-family: 'El Messiri'; color: #5C215F; font-size: 32px; text-align: center;"
    v-if="$route.params.one_year == null"
>
    Your Tour<br/>
    <span style="font-size: 20px">July 3rd, 2019</span>
</div>

<div
    style="font-family: 'El Messiri'; color: #5C215F; font-size: 32px; text-align: center;"
    v-if="$route.params.one_year != null"
>
    One year ago today...<br/>
    <span style="font-size: 20px">July 3rd, 2019</span>
</div>

<v-container>

    <m-platypus-tour-card
        hero_src="razita-hero.jpg"
        logo_src="razi-logo-v1.png"
        tagline="A small, boutique winery nestled in the Silverado Trail of Napa, California, Razi Winery has been family-owned and operated since 1995."
    />



    <m-platypus-tour-card
        hero_src="farmstead-hero2.png"
        logo_src="farmstead-logo.png"
        tagline="A farm to table restaurant where our connection to rugged mountain terrain, mineral-rich riverbed benchland, and the cool coastal air is tangible."
    />

    <m-platypus-tour-card
        hero_src="florasprings.jpeg"
        logo_src="florasprings-logo.png"
        tagline="Family-owned and operated since 1978 in Napa Valley. Flora Springs is committed to producing sustainably farmed, handcrafted wines."
    />

   <m-platypus-tour-card
        hero_src="reynolds-hero.png"
        logo_src="reynolds-logo.png"
        tagline="As you might have surmised by the name, weare a family business.  We live and work here and, over the years, have manager to fashion our dream into a wondrous life in Napa valley."
    />

   <div
    style="font-family: 'El Messiri'; color: #5C215F; font-size: 32px; text-align: center; margin-top: 15px;"
>
    Your Photos

    <p>
    <img
        src="@/assets/platypus/img1.jpg"
        style="max-width: 325px; margin-bottom: 15px;"
    />
    </p>

    <p>
    <img
        src="@/assets/platypus/img5.jpg"
        style="max-width: 325px; margin-bottom: 15px;"
    />
    </p>

    <p>
     <img
        src="@/assets/platypus/img2.jpg"
        style="max-width: 325px; margin-bottom: 15px;"
    />
    </p>

    <p>
    <img
        src="@/assets/platypus/img3.jpg"
        style="max-width: 325px; margin-bottom: 15px;"
    />
    </p>

    <p>
    <img
        src="@/assets/platypus/img4.jpg"
        style="max-width: 325px; margin-bottom: 15px;"
    />
    </p>

   

</div>

</v-container>
</v-app>
</template>

<script>
export default {
    data() {
        return {
        }
    },
}
</script>

<style lang="scss" scoped>
</style>